import { render, staticRenderFns } from "./icon-warning.vue?vue&type=template&id=46fe8f31&"
import script from "./icon-warning.vue?vue&type=script&lang=ts&"
export * from "./icon-warning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fe8f31')) {
      api.createRecord('46fe8f31', component.options)
    } else {
      api.reload('46fe8f31', component.options)
    }
    module.hot.accept("./icon-warning.vue?vue&type=template&id=46fe8f31&", function () {
      api.rerender('46fe8f31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/result/src/icon-warning.vue"
export default component.exports